<script>
import { Bar } from 'vue-chartjs'
// import the component - chart you need

export default {
  name: 'barChart',
  extends: Bar,
  props: ['data', 'options'],
  mounted () {
    // Overwriting base render method with actual data.
    this.renderChart(this.data, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// src/app/programguide/components/BarChart.vue